import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { ActionSheetContent } from '@/components/action-sheet';
import { useNewOrderActionsContext } from '@/contexts/new-order-actions-context';
import { useNewOrderContext } from '@/contexts/new-order-context';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  onCancel: () => void;
  onCleared: () => void;
}

export const ClearCartConfirmation: React.FC<Props> = ({
  onCancel,
  onCleared,
}) => {
  const { clearCart } = useNewOrderActionsContext();
  const { multiCartEnabled } = useNewOrderContext();
  const { showErrorToast } = useToasts();
  const [isClearing, setIsClearing] = useState(false);

  return (
    <ActionSheetContent
      actions={[
        multiCartEnabled ? i18n.t('remove') : i18n.t('clear'),
        i18n.t('cancel'),
      ]}
      horizontalButtons
      loadingActionIndex={isClearing ? 0 : null}
      onAction={async (_, index) => {
        if (index !== 0) {
          onCancel();
          return;
        }
        setIsClearing(true);
        try {
          const result = await clearCart();
          if (result.success) {
            onCleared();
          } else {
            showErrorToast();
          }
        } catch {
          showErrorToast();
        } finally {
          setIsClearing(false);
        }
      }}
      title={
        multiCartEnabled
          ? i18n.t('multi_cart.remove_all_items_title')
          : i18n.t('clear_items_confirmation')
      }
    />
  );
};
